import { useEffect } from 'react';
import { useApiStatusToast } from 'shared/hooks/useApiStatusToast';
import type { Toast } from 'shared/ui/use-toast';

interface IToastError extends Toast {
  isError: boolean;
}

export const useOnError = ({
  isError,
  title = 'Произошла ошибка',
  description,
  ...props
}: IToastError) => {
  const [_, handleError] = useApiStatusToast();
  useEffect(() => {
    if (isError)
      handleError({ description: description ?? title, title, ...props });
  }, [isError]);
};
